import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
import { emailApiResponseSuccess, emailApiResponseError } from './actions';
import { EmailsActionTypes } from './constants';
import { toggleLoading } from '../actions';
import {
    createEmail as createEmailApi,
    createEmailAttachment as createEmailAttachmentApi,
    getEmail as getEmailApi,
    getEmails as getEmailsApi,
    getEmailsByUser as getEmailsByUserApi,
    getEmailsByTransaction as getEmailsByTransactionApi,
    updateEmail as updateEmailApi,
} from '../../helpers';

/**
 * Get Emails
 * @param {object} action
 * @param {string} action.payload
 */
function* getEmails({ payload: {} }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getEmailsApi);
        yield put(emailApiResponseSuccess(EmailsActionTypes.GET_EMAILS, response.data));
    } catch (error) {
        console.log(error);
        yield put(emailApiResponseError(EmailsActionTypes.GET_EMAILS, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Get Emails by ID
 * @param {object} action
 * @param {string} action.payload
 * @param {string} action.payload.id
 */
function* getEmail({ payload: { id } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getEmailApi, { id });
        yield put(emailApiResponseSuccess(EmailsActionTypes.GET_EMAIL_BY_ID, response.data));
    } catch (error) {
        console.log(error);
        yield put(emailApiResponseError(EmailsActionTypes.GET_EMAIL_BY_ID, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Get Emails by User
 * @param {object} action
 * @param {string} action.payload
 * @param {string} action.payload.user
 */
function* getEmailsByUser({ payload: { user } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getEmailsByUserApi, { user });
        yield put(emailApiResponseSuccess(EmailsActionTypes.GET_EMAILS_BY_USER, response.data));
    } catch (error) {
        console.log(error);
        yield put(emailApiResponseError(EmailsActionTypes.GET_EMAILS_BY_USER, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Get Emails by User
 * @param {object} action
 * @param {string} action.payload
 * @param {string} action.payload.user
 */
function* getEmailsByTransaction({ payload: { transaction } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getEmailsByTransactionApi, { transaction });
        yield put(emailApiResponseSuccess(EmailsActionTypes.GET_EMAILS_BY_TRANSACTION, response.data));
    } catch (error) {
        console.log(error);
        yield put(emailApiResponseError(EmailsActionTypes.GET_EMAILS_BY_TRANSACTION, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Create a new email
 * @param {object} action
 * @param {string} action.payload
 * @param {string} action.payload.parent
 * @param {string} action.payload.id
 * @param {string} action.payload.data
 */
function* createEmail({ payload: { parent, id, data } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(createEmailApi, { parent, id, data });
        const file = response.data;
        yield put(emailApiResponseSuccess(EmailsActionTypes.CREATE_EMAIL, file));
    } catch (error) {
        console.log(error);
        yield put(emailApiResponseError(EmailsActionTypes.CREATE_EMAIL, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Update a Email
 * @param {object} action
 * @param {string} action.payload
 * @param {string} action.payload.id
 * @param {object} action.payload.data
 */
function* updateEmail({ payload: { id, data } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(updateEmailApi, { id, data });
        yield put(emailApiResponseSuccess(EmailsActionTypes.UPDATE_EMAIL, response.data));
    } catch (error) {
        console.log(error);
        yield put(emailApiResponseError(EmailsActionTypes.UPDATE_EMAIL, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Comment on a email
 * @param {object} action
 * @param {string} action.payload
 * @param {object} action.payload.data
 */
function* createEmailAttachment({ payload: { id, data } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(createEmailAttachmentApi, { id, data });
        yield put(emailApiResponseSuccess(EmailsActionTypes.CREATE_ATTACHMENT, response.data));
    } catch (error) {
        console.log(error);
        yield put(emailApiResponseError(EmailsActionTypes.CREATE_ATTACHMENT, error));
    }
    yield put(toggleLoading(false));
}

export function* watchGetEmails() {
    yield takeEvery(EmailsActionTypes.GET_EMAILS, getEmails);
}

export function* watchGetEmail() {
    yield takeEvery(EmailsActionTypes.GET_EMAIL_BY_ID, getEmail);
}

export function* watchGetEmailsByUser() {
    yield takeEvery(EmailsActionTypes.GET_EMAILS_BY_USER, getEmailsByUser);
}

export function* watchGetEmailsByTransaction() {
    yield takeEvery(EmailsActionTypes.GET_EMAILS_BY_TRANSACTION, getEmailsByTransaction);
}

export function* watchCreateEmail() {
    yield takeEvery(EmailsActionTypes.CREATE_EMAIL, createEmail);
}

export function* watchUpdateEmail() {
    yield takeEvery(EmailsActionTypes.UPDATE_EMAIL, updateEmail);
}

export function* watchCreateEmailAttachment() {
    yield takeEvery(EmailsActionTypes.CREATE_ATTACHMENT, createEmailAttachment);
}

function* emailSaga() {
    yield all([
        fork(watchGetEmails),
        fork(watchGetEmail),
        fork(watchGetEmailsByUser),
        fork(watchGetEmailsByTransaction),
        fork(watchUpdateEmail),
        fork(watchCreateEmail),
        fork(watchCreateEmailAttachment),
    ]);
}

export default emailSaga;
